import React from "react";
import { AlertCircle } from "../../icons/line.tsx";
import * as styles from "./ErrorIcon.css.ts";

const ErrorIcon: React.FC = () => {
  return <AlertCircle className={styles.errorIcon} />;
};

export default ErrorIcon;
